import { Clock } from '@phosphor-icons/react';
import { useCrons } from '~/hooks/queries/use-crons';
import { Tip } from '~/components/ui/tip';

function relFuture(iso?: string): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const diff = d.getTime() - Date.now();
  if (diff <= 0) return 'due';
  if (diff < 60_000) return '<1m';
  if (diff < 3_600_000) return `${Math.round(diff / 60_000)}m`;
  if (diff < 86_400_000) return `${Math.round(diff / 3_600_000)}h`;
  return `${Math.round(diff / 86_400_000)}d`;
}

export function UpcomingCrons() {
  const { items: crons, isLoading } = useCrons();

  if (isLoading) {
    return <div className="text-xs text-muted-foreground/70 py-1">Loading…</div>;
  }

  const upcoming = crons
    .filter((c) => c.enabled && c.nextRunAt)
    .sort((a, b) =>
      new Date(a.nextRunAt!).getTime() - new Date(b.nextRunAt!).getTime(),
    )
    .slice(0, 6);

  if (upcoming.length === 0) {
    return <div className="text-xs text-muted-foreground/70 py-1">Nothing scheduled.</div>;
  }

  return (
    <div className="flex flex-col gap-1">
      {upcoming.map((c) => (
        <Tip key={c.id} label={c.nextRunAt}>
          <div
            className="flex items-center gap-2 px-1 py-0.5 text-xs text-muted-foreground"
          >
            <Clock size={11} className="text-muted-foreground/60 shrink-0" />
            <span className="truncate flex-1 text-foreground/80">{c.name}</span>
            <span className="tabular-nums shrink-0">{relFuture(c.nextRunAt)}</span>
          </div>
        </Tip>
      ))}
    </div>
  );
}
